
  <mat-chip-set class="labels-bar" aria-label="Labels or tags" >
    <mat-chip *ngFor="let label of this.jobLabels"
      matTooltip="{{ label.tooltip }}"
      class="label {{ label.color }}"
    >
      {{ label.key }}
    </mat-chip>
  </mat-chip-set>